import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();

  // Update breadcrumbs whenever the location changes
  React.useEffect(() => {
    const pathSegments = location.pathname.split('/').filter((segment) => segment !== '');

    const newBreadcrumbs = pathSegments.map((segment, index) => ({
      label: segment,
      path: `/${pathSegments.slice(0, index + 1).join('/')}`,
    }));

    setBreadcrumbs(newBreadcrumbs);
  }, [location]);

  return (

    <>
    
    {/* <div className='mt-24 mx-16 p-2 bg-gray-300 text-lg font-heading'>
      <Link to="/" className='text-black hover:text-blue-700 transition duration-300'>Home</Link>
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={breadcrumb.path}>
          <span className='mx-2 text-gray-500'>/</span>
          <Link to={breadcrumb.path} className='text-blue-500 hover:text-blue-700 transition duration-300'>{breadcrumb.label}</Link>
        </span>
      ))}
    </div> */}

    

<nav class="flex px-5 py-3 mt-24 mx-16 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700" aria-label="Breadcrumb">
  <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
    <li class="inline-flex items-center">
      <Link to="/"> 
      <p class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
        <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
        </svg>
        Home
      </p>
      </Link>
    </li>
    
    <li aria-current="page">
      <div class="flex items-center">
        <svg class="rtl:rotate-180  w-3 h-3 mx-1 text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
        </svg>
        {breadcrumbs.map((breadcrumb, index) => (
        <span key={breadcrumb.path}>
          <span className='mx-2 text-gray-500'>/</span>
          <Link to={breadcrumb.path} className='ms-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white'>{breadcrumb.label}</Link>
        </span>
      ))}
            </div>
    </li>
  </ol>
</nav>

    </>

    
  );
};

export default Breadcrumbs;
